<template>
  <VUEModal v-if="PopupSegmentiVelocita"
            :Titolo="this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_SEL_SEGM_TEMP',this.LinguaUtente)"
            :Altezza="'340px'" :Larghezza="'1000px'"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            :AllowMovement = MovimentoModal
            @onClickChiudiModal="AnnullaPopupSegmentiVelocita">
    <template v-slot:Body>

      <VUEModal v-if="PopupNumeroSegmentiDaAggiungere"
                :Titolo="''" :Altezza="'120px'"
                :Larghezza="'400px'"
                :PathLogo="require('@/assets/images/LogoDMS.png')"
                :Programma="'DMSEW'"
                @onClickChiudiModal="PopupNumeroSegmentiDaAggiungere = false; MovimentoModal = true">
        
        <template v-slot:Body>
          <label style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_INS_N_SEGM',this.LinguaUtente) }}</label>
          <input type="number" class="form-control" step="1" v-model="NumeroSegmentidaAggiungere" :placeholder="this.GetTraduzioneLabel('Generic','TKN_NUMERO_SEGMENTI',this.LinguaUtente)"/>
        </template>

        <template v-slot:Footer>
          <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:35%" @click="PopupNumeroSegmentiDaAggiungere = false; MovimentoModal = true" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:35%" @click="OnClickConfermaNSegmentiDaAggiungere" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
        </template>

      </VUEModal>

      <div style="width: 80%; float: left; max-height: 1200px; overflow-y: auto; overflow-x: hidden;">
        <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">       
          <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_LISTA_SEGM',this.LinguaUtente) }}</text>
        </div>
        
        <VUEDataTable :DataTable="DataTablePopup.DataTableSegmenti" :NumeroRighe = NumeroMassimoRisultati />
        
      </div>

      <div style="width:20%;float: left;">

        <div style="margin-top:5px">

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="float: left; width:95%">
            <button type="button" class="btn btn-info" @click="OnClickAggiungiSegmento" style="width: 100%">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_ADD_ONE_SEGM',this.LinguaUtente) }}</button>
          </div>

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="clear: both; height:4px"></div>
          
          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="float: left; width:95%">
            <button type="button" class="btn btn-info" @click="OnClickEliminaTuttiSegmenti" style="width: 100%">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_DEL_SEGM',this.LinguaUtente) }}</button>
          </div>

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="clear: both; height:4px"></div>

          <div style="float: left; width:2%;">&nbsp;</div>

          <div style="float: left; width:95%">
            <button type="button" class="btn btn-info" @click="OnClickAggiungiNSegmenti" style="width: 100%">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_ADD_N_SEGM',this.LinguaUtente) }}</button>
          </div>

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="clear: both; height:4px"></div>

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="float: left; width:95%">
            <button type="button" class="btn btn-info" @click="OnClickRinumeraSegmenti" style="width: 100%">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_RINUM_SEGM',this.LinguaUtente) }}</button>
          </div>

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="clear: both; height:20px"></div>

          <!-- <div style="float: left; width:2%;">&nbsp;</div>
          <div style="float: left; width:96%">
            <button type="button" class="btn btn-info" style="width: 100%">Salva lista segmenti</button>
          </div>
          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="clear: both; height:4px"></div>

          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="float: left; width:96%">
            <button type="button" class="btn btn-info" style="width: 100%">Carica lista segmenti</button>
          </div>
          <div style="float: left; width:2%;">&nbsp;</div>
          <div style="clear: both; height:2px"></div> -->
        </div>
      
      </div>
    
    </template>

    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupSegmentiVelocita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="BottoneConfermaSegmentiAbilitato" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupSegmentiVelocita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  
  </VUEModal>

  <VUEModal v-if="PopupUdmX"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)"
            :Altezza="'80px'"
            :Larghezza="'500px'"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupUdmX()">

    <template v-slot:Body>

      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="ObjGrafico.AxisX.UdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

      </div>

    </template>

    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjGrafico.AxisX.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>

  </VUEModal>

  <VUEModal v-if="PopupImpostazioniAsseY"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)"
            Altezza="150px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupImpostazioniY()">

    <template v-slot:Body>
      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">

        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="ObjGrafico.AxisY.Min" @blur="ObjGrafico.AxisY.Min = ConvertiValoreInCentesimi(ObjGrafico.AxisY.Min)">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>

        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="ObjGrafico.AxisY.Max" @blur="ObjGrafico.AxisY.Max = ConvertiValoreInCentesimi(ObjGrafico.AxisY.Max)">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>

        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="ObjGrafico.AxisY.Udm" @blur="ObjGrafico.AxisY.Udm = ConvertiValoreInCentesimi(ObjGrafico.AxisY.Udm)">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p>
        </div>

      </div>

    </template>

    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>

  </VUEModal>

  <VUEModal v-if="PopupAddRighello"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)"
            Altezza="140px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupAddRighello()">

    <template v-slot:Body>
      
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="font-weight:bold;width: 120px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
          <div style="width: 70%; display: flex; justify-content: space-between">
            <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
            <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
          </div>
        </div>

        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
          <p style="font-weight:bold;width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
          <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
        </div>

      </div>

    </template>

    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>

  </VUEModal>

  <VUEModal v-if="PopupRemoveRighello"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)"
            Altezza="140px"
            Larghezza="500px"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupRemoveRighello()">
    
    <template v-slot:Body>

      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 50%; display: flex; justify-content: space-between">
          <select class="form-control" v-model="RighelloToRemove">
            <option :value="''">-</option>
            <option v-for="Righello in ObjGrafico.ListaRighelli"
                    :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
          </select>
        </div>
      </div>

    </template>

    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>

  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker"
                  Programma="DMSEW"
                  :Colore="ColoreInModifica"
                  @OnClickConfermaPopup="ConfermaColore()"
                  @OnClickChiudiPopup="AnnullaColore()" />
  
  <div style="min-height:350px;">

    <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">       
      <text v-if="CurrentOggettoTotaleSpostamento != null" style="font-weight: bold;">{{this.GetTraduzioneLabel('Generic','TKN_TOTALE',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROFONDITA_DA',this.LinguaUtente) + ' ' + (OggettoTotaleSpostamento.MinProfondita) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_LETT_A',this.LinguaUtente) + ' ' + OggettoTotaleSpostamento.MaxProfondita + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('Generic','TKN_DIREZIONE_RIFERIMENTO',this.LinguaUtente) + ' (' + OrientamentoAsse + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + this.GetTraduzioneLabel('UdmGenerali','TKN_GRADI_NORD',this.LinguaUtente) + ')'}}</text>
      <text v-else style="font-weight: bold;">{{this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + Modulo.Id + ' ' + this.GetTraduzioneLabel('Generic','TKN_INCLINAZIONI',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROFONDITA_DA',this.LinguaUtente) + ' ' + Modulo.Profondita + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_LETT_A',this.LinguaUtente) + ' ' + (Modulo.Profondita + Modulo.Lunghezza) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('Generic','TKN_DIREZIONE_RIFERIMENTO',this.LinguaUtente) + ' (' + OrientamentoAsse + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + this.GetTraduzioneLabel('UdmGenerali','TKN_GRADI_NORD',this.LinguaUtente) + ')'}}</text>
    </div>
    <div style="width:89%;float: left;" :style="{'cursor' : AbilitaDisegnaVelocita ? 'crosshair' : ''}" ref="DivCanvas">
      <VUEComponenteGraficoSpostamenti :WidthGrafico="GrandezzaCanvas.Width" 
                                       :HeightGrafico="GrandezzaCanvas.Height"
                                       :Modulo="Modulo"
                                       :ObjDal="ObjDal"
                                       :ObjAl="ObjAl"
                                       :TipoGrafico="TipoGrafico"
                                       :PropsGrafico="ObjGrafico"
                                       :Repaint="Repaint"
                                       :GraficiChange="GraficiChange"
                                       :PressAdatta="PressAdatta"
                                       :IsVelocita="CurrentIsVelocita"
                                       :IsAccelerazione="CurrentIsAccelerazione"
                                       :IsVelocitaGiornaliera="CurrentIsVelocitaGiornaliera"
                                       :IsAccelerazioneGiornaliera="CurrentIsAccelerazioneGiornaliera"
                                       :ListaFalde="ListaFaldeSelezionate"
                                       :AbilitaDisegnaVelocita="AbilitaDisegnaVelocita"
                                       :ListaFaldeChange="ListaFaldeChange"
                                       :ListaSegmenti="ListaSegmenti"
                                       :OggettoTotaleSpostamento="OggettoTotaleSpostamento"
                                       :SoglieAllarmi="SoglieAllarmi"/>
    </div>
    
    <!-- <div style="width:17%; float: left; border: solid 1px black; margin-top:24px" ref="DivButtons"> -->
    <div style="width:9%; float: right; margin-top:16px; margin-right: 10px;" ref="DivButtons">
      
      <div id="ContainerTasti">
        
        <div v-if="CurrentIsVelocita">
          <div style="float: left; width:95%;">
            <label style="color:blue">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_VEL_H',this.LinguaUtente) }}</label>
          </div> 
        </div>

        <div v-else-if="CurrentIsVelocitaGiornaliera">
            <div style="float: left; width:95%;">
              <label style="color:green">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_VEL_GG',this.LinguaUtente) }}</label>
            </div>
            <div style="clear: both; height: 1px"></div>
            <div style="float: left; width:10%;">
              <input style="float: left;height:100%" v-model="ObjGrafico.CbSoglieAllarmi" type="checkbox" class="form-control"/>
            </div> 
            <div style="float: left; width:90%;">
              <label style="float: left;font-size:14px;margin-bottom:4px">&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_SOGLIE_ALLARME',this.LinguaUtente) }}</label>
            </div> 
            <div style="clear: both"></div>
        </div>

        <div v-else-if="CurrentIsAccelerazione">
          <div style="float: left; width:4%;">&nbsp;</div>
          <div style="float: left; width:92%;">
            <div style="float: left; width:5%;">
            </div> 
            <div style="float: left; width:95%;">
              <label style="color:blue">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_ACC_H',this.LinguaUtente) }}</label>
            </div> 
            <div style="clear: both; height: 1px"></div>
          </div>
          <div style="clear: both"></div>
        </div>

        <div v-else-if="CurrentIsAccelerazioneGiornaliera">
          <div style="float: left; width:4%;">&nbsp;</div>
          <div style="float: left; width:92%;">
            <div style="float: left; width:5%;">
            </div> 
            <div style="float: left; width:95%;">
              <label style="color:green">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_ACC_GG',this.LinguaUtente) }}</label>
            </div> 
            <div style="clear: both; height: 1px"></div>
          </div>
          <div style="clear: both"></div>
        </div>

        <div v-else>
          <div>
            <label style="color: navy">{{ this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) }}</label>
          </div>
          
          <div>
            <label v-if="FaldaNumero1 != null" :style="{color : ColoriFalde[0]}">{{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ FaldaNumero1 }}</label>
          </div>

          <div>
            <label v-if="FaldaNumero2 != null" :style="{color : ColoriFalde[1]}">{{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ FaldaNumero2 }}</label>
          </div>

          <div>
            <label v-if="FaldaNumero3 != null"  :style="{color : ColoriFalde[2]}">{{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ FaldaNumero3 }}</label>
          </div>
        </div>

        <button :disabled="AbilitaDisegnaVelocita" type="button" class="btn btn-info" @click="OnClickAdatta" style="width: 100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente) }}</button>
        <button :disabled="AbilitaDisegnaVelocita" type="button" class="btn btn-info" @click="OnClickUdmX" style="width: 100%">{{ this.GetTraduzioneLabel('Generic','TKN_UDM_X',this.LinguaUtente) }}</button>
        <button :disabled="AbilitaDisegnaVelocita" type="button" class="btn btn-info" @click="ApriPopupImpostazioniY" style="width: 100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente) }}</button>
        <button :disabled="AbilitaDisegnaVelocita" type="button" class="btn btn-info" @click="ApriPopupAddRighello" style="width: 100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADD_RIGHELLO',this.LinguaUtente) }}</button>
        <button :disabled="ObjGrafico.ListaRighelli.length == 0" type="button" class="btn btn-info" @click="ApriPopupRemoveRighello()" style="width: 100%">{{ this.GetTraduzioneLabel('Generic','TKN_DEL_RIGHELLO',this.LinguaUtente) }}</button>

        <div v-if="TipoGrafico == TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI">
          <button :disabled="AbilitaDisegnaVelocita" type="button" class="btn btn-info" style="width: 80%" @click="ApriPopupSegmentiVelocita">{{ this.GetTraduzioneLabel('Generic','TKN_VELOCITA',this.LinguaUtente) }}</button>
          <span style="width: 3%;">&nbsp;</span>
          <button :title="this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_TITOLO_SEGNA_VEL_GRAF',this.LinguaUtente)" class="btn btn-info fa fa-crosshairs" style="width: 16%;padding: 0" @click="DisegnaVelocitaSuGrafico" :style="{backgroundColor : AbilitaDisegnaVelocita ? '#006400' : '#8B0000'}" ></button>
        </div>
        
        <div v-if="CurrentListaFaldeFiltrata.length > 0 || this.FaldaNumero1 != null" style="margin-top: 5px;">

          <label>{{ this.GetTraduzioneLabel('Generic','TKN_FALDA',this.LinguaUtente) }}</label>

          <div class="ContainerFalde">
          
            <div class="ContainerLabelEBottoneFalda">
          
              <ul class="nav navbar-right m-n" style="margin: 0;padding: 0;">
                <li class="dropdown open" style="z-index: 9999;">
                  
                  <a style="padding: 0!important; padding-left: 5px!important;" v-if="FaldaNumero1 == null" @click="ToggleMenuFalde(1)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">-</a>
                  <a v-else style="font-size: 12px; padding: 0!important; padding-left: 5px!important;" @click="ToggleMenuFalde(1)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ FaldaNumero1 }}</a>
                  
                  <ul v-if="this.FlagMenuFalde" class="dropdown-menu">
                    <li v-for="Falda in CurrentListaFaldeFiltrata" :Key="Falda.Id" :value="Falda.Id" >
                      <a @click="OnChangeFalda(Falda.Id, 1)" style="font-size: 12px" >{{Falda.Id != null ? this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) + Falda.Id : '-'}}</a>
                    </li>
                  </ul>
                
                </li>
              </ul>
              
              <!-- <div class="ContainerBottoniFalda">
                <button @click="OnClickBottoneAggiungiFalda()" class="btn btn-info" :disabled="CurrentListaFaldeFiltrata.length <= 1">+</button>
                <button @click="OnClickBottoneSvuotaFalda()" class="btn btn-danger">-</button>
              </div> -->
            </div>
            
            <div v-if="CurrentListaFaldeFiltrata.slice(1).length > 1" class="ContainerLabelEBottoneFalda">
              <ul class="nav navbar-right m-n" style="margin: 0;padding: 0;">
                <li class="dropdown open" style="z-index: 9998;">
                  
                  <a style="padding: 0!important; padding-left: 5px!important;" v-if="FaldaNumero2 == null" @click="ToggleMenuFalde(2)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">-</a>
                  <a v-else style="font-size: 12px; padding: 0!important; padding-left: 5px!important;" @click="ToggleMenuFalde(2)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ FaldaNumero2 }}</a>
                  
                  <ul v-if="this.FlagMenuFalde2" class="dropdown-menu">
                    <li v-for="Falda in CurrentListaFaldeFiltrata" :Key="Falda.Id" :value="Falda.Id">
                    <a @click="OnChangeFalda(Falda.Id, 2)" style="font-size: 12px" >{{Falda.Id != null ? this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) + Falda.Id : '-'}}</a>

                    </li>
                  </ul>
                </li>
              </ul>
              
              <!-- <div class="ContainerBottoniFalda">
                <button @click="OnClickBottoneAggiungiFalda()" class="btn btn-info">+</button>
                <button @click="OnClickBottoneSvuotaFalda()" class="btn btn-danger">-</button>
              </div> -->
            </div>

            <div v-if="CurrentListaFaldeFiltrata.slice(1).length > 2" class="ContainerLabelEBottoneFalda">
              <ul class="nav navbar-right m-n" style="margin: 0;padding: 0;">
                <li class="dropdown open" style="z-index: 9997;">
                  
                  <a style="padding: 0!important; padding-left: 5px!important;" v-if="FaldaNumero3 == null" @click="ToggleMenuFalde(3)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">-</a>
                  <a v-else style="font-size: 12px; padding: 0!important; padding-left: 5px!important;" @click="ToggleMenuFalde(3)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{ this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) }} {{ FaldaNumero3 }}</a>
                  
                  <ul v-if="this.FlagMenuFalde3" class="dropdown-menu">
                    <li v-for="Falda in CurrentListaFaldeFiltrata" :Key="Falda.Id" :value="Falda.Id">
                      <a @click="OnChangeFalda(Falda.Id, 3)" style="font-size: 12px" >{{Falda.Id != null ? this.GetTraduzioneLabel('Generic','TKN_N_PIEZOMETRO',this.LinguaUtente) + Falda.Id : '-'}}</a>
                    </li>
                  </ul>
                </li>
              </ul>
              
              <!-- <div class="ContainerBottoniFalda">
                <button @click="OnClickBottoneAggiungiFalda()" class="btn btn-info" :disabled="ContatoreFalde == 2">+</button>
                <button @click="OnClickBottoneSvuotaFalda()" class="btn btn-danger">-</button>
              </div> -->

            </div>

          </div>
        </div>

        <button type="button" class="btn btn-info" @click="EsportaComePDF()" style="width: 100%">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
              
      </div>   
      <div style="float: left;">&nbsp;</div>
    </div>
  </div>
  <div style="clear: both"></div>

</template>

<script>
import { COLORI_PANTONE, SystemInformation, TIPI_UDM_X, TIPOLOGIA_GRAFICI_STORICI, COLORI_FALDE } from '@/SystemInformation'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEDataTable from '@/utils/VUEDataTable.vue'
import VUEModal from '@/utils/VUEModal.vue'
// import { TZDateFunct } from '@/utils/ZDateFunct'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import VUEComponenteGraficoSpostamenti from './VUEComponenteGraficoSpostamenti.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler'

export default 
{
  data()
  {
   return {
            ColoriPantone                   : COLORI_PANTONE,
            OrientamentoAsse                : SystemInformation.OggettoInfoGraficiStorici.OrientamentoAsse,
            TipiUdmX                        : TIPI_UDM_X,
            TipoUdmX                        : 0,
            GrandezzaCanvas                 : {
                                                Width  : 0,
                                                Height : 0
                                              },
            ObjGrafico                      : {
                                                CbSoglieAllarmi : true,
                                                AxisY  : {
                                                            Min : 0,
                                                            Max : 0,
                                                            Udm : 0,
                                                            Modificato : false,
                                                         },
                                              },
            PopupUdmX                       : false,
            Repaint                         : 0,
            PressAdatta                     : 0,
            PopupImpostazioniAsseY          : false,
            PopupAddRighello                : false,
            PopupRemoveRighello             : false,
            PopupColorPicker                : false,
            AbilitaDisegnaVelocita          : false,
            ColoreInModifica                : { Colore: '#000000' },
            ObjNewRighello                  : { Data: '', Ora : '', PrettyDateTime: '', Colore: '#000000' },
            RighelloToRemove                : '',
            TipologiaGrafici                : TIPOLOGIA_GRAFICI_STORICI,
            FaldaNumero1                    : null,
            FaldaNumero2                    : null,
            FaldaNumero3                    : null,
            PopupSegmentiVelocita           : false,
            DataTablePopup                  : null,
            PopupNumeroSegmentiDaAggiungere : false,
            NumeroSegmentidaAggiungere      : 1,
            ListaFaldeSelezionate           : [],
            ListaFaldeChange                : 0,
            ListaSegmenti                   : [],
            ColoreBottoni                   : COLORI_PANTONE.Marrone,
            ColoriFalde                     : COLORI_FALDE,
            ListaIdFaldeSelezionate         : [],
            FlagMenuFalde                   : false,
            FlagMenuFalde2                  : false,
            FlagMenuFalde3                  : false,
            LinguaUtente                    : SystemInformation.UserInformation.Lingua,
            ContatoreFalde                  : 0,
            NumeroMassimoRisultati          : 5,
            MovimentoModal                  : true
          }
  },

  props: [
           'Modulo',
           'ObjDal',
           'ObjAl',
           'TipoGrafico',
           'GraficiChange',
           'IsVelocita',
           'IsAccelerazione',
           'IsVelocitaGiornaliera',
           'IsAccelerazioneGiornaliera',
           'ListaFalde',
           'OggettoTotaleSpostamento',
           'ParametriPDF',
           'GetDatiPDF',
           'SoglieAllarmi'
         ],
  emits: ['EsportaPDFGrafico'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni, MixInsGraficiStorici],
  components: {
                VUEComponenteGraficoSpostamenti,
                VUEModal,
                VUEColorPicker,
                VUEDataTable
              },

  methods:
  {
    EsportaComePDF()
    {
      let IdModulo = -2
      if (this.Modulo != null)
        IdModulo = this.Modulo.Id
      this.$emit('EsportaPDFGrafico', IdModulo)
    },

    ConvertiValoreInCentesimi(Valore)
    {
      let Numero = TZMathFunct.GetMultiplo(Valore, 0.01, 'Eccesso')
      
      return Number(Numero.toFixed(2))
    },

    GetGraficiPDF()
    {
      let ListaFalde = []

      for (let i = 0; i < this.ListaFaldeSelezionate.length; i++)
      {
        let SingolaFalda = TZGenericFunct.GetCopyOfObject(this.ListaFaldeSelezionate[i])
        SingolaFalda.Dati = []
        ListaFalde.push(SingolaFalda)
      }

      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []

      let ModuloPDF = TZGenericFunct.GetCopyOfObject(this.Modulo)
      ModuloPDF.ListaFalde = []
      ModuloPDF.ListaFalde.push(ListaFalde)
      
      let ArrayOggettoGrafico = TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico)
      
      if(ArrayOggettoGrafico.OtherAxis != undefined && ArrayOggettoGrafico.OtherAxis.length > 0)
      {
        ArrayOggettoGrafico.OtherAxis.forEach(AsseAlternativa => { AsseAlternativa.NotchFontSize = 17 });
      }
      
      ArrayOggettoGrafico.SogliePresenti   = this.ObjGrafico.CbSoglieAllarmi != undefined ? this.ObjGrafico.CbSoglieAllarmi : false
      ArrayOggettoGrafico.SegmentiVelocita = this.ListaSegmenti

      this.ObjPDF.PDFModulo.push(ModuloPDF)
      this.ObjPDF.PDFObjDatiGrafici.push(ArrayOggettoGrafico)
    },

    OnChangeFalda(IdFalda, NumeroFalda)
    {
      if(NumeroFalda == 1)
      { 
        this.FaldaNumero1 = IdFalda
        this.FlagMenuFalde = false
      }

      if(NumeroFalda == 2)
      {
        this.FaldaNumero2 = IdFalda
        this.FlagMenuFalde2 = false
      }

      if(NumeroFalda == 3)
      {
        this.FaldaNumero3 = IdFalda
        this.FlagMenuFalde3 = false
      }

      if(IdFalda != null)
        this.ListaIdFaldeSelezionate[NumeroFalda - 1] = IdFalda
      else
        this.ListaIdFaldeSelezionate.splice(NumeroFalda - 1)

      this.AggiungiFaldeSelezionate()
      this.ListaFaldeChange++
    },

    AggiungiFaldeSelezionate()
    {
      this.ListaFaldeSelezionate = []


      for(let i = 0; i < this.CurrentListaFalde.length; i++)
      {
        if(this.FaldaNumero1 === this.CurrentListaFalde[i].Id)
          this.ListaFaldeSelezionate.push(this.CurrentListaFalde[i])

        if(this.FaldaNumero2 === this.CurrentListaFalde[i].Id)
          this.ListaFaldeSelezionate.push(this.CurrentListaFalde[i])

        if(this.FaldaNumero3 === this.CurrentListaFalde[i].Id)
          this.ListaFaldeSelezionate.push(this.CurrentListaFalde[i])
      }
    },

    ControlloFaldeSelezionate()
    {
      for(let i = 0; i < this.CurrentListaFalde.length; i++)
      {
        let Presente = false
        if(this.FaldaNumero1 != null)
          if(this.FaldaNumero1 == this.CurrentListaFalde[i].Id)
            Presente = true

        if(this.FaldaNumero2 != null)
          if(this.FaldaNumero2 == this.CurrentListaFalde[i].Id)
            Presente = true

        if(this.FaldaNumero3 != null)
          if(this.FaldaNumero3 == this.CurrentListaFalde[i].Id)
            Presente = true
        
        if(Presente)
          this.CurrentListaFalde[i].Selezionata = true
        else this.CurrentListaFalde[i].Selezionata = false
      }
    },

    OnClickEliminaTuttiSegmenti()
    {
      this.DataTablePopup.EliminaTuttiSegmenti()
    },

    OnClickAggiungiSegmento()
    {
      this.DataTablePopup.AggiungiSegmento()
    },

    OnClickAggiungiNSegmenti()
    {
      this.MovimentoModal = false;
      this.NumeroSegmentidaAggiungere      = 1
      this.PopupNumeroSegmentiDaAggiungere = true
    },

    OnClickConfermaNSegmentiDaAggiungere()
    {
      this.MovimentoModal = true;
      let DatiSpostamento

      if(this.OggettoTotaleSpostamento != undefined && this.OggettoTotaleSpostamento.ListaTotaliSpostamento != undefined)
        DatiSpostamento = this.OggettoTotaleSpostamento.ListaTotaliSpostamento

      if(this.Modulo != undefined)
        DatiSpostamento = this.Modulo.Dati
      
      this.DataTablePopup.AggiungiNSegmenti(this.NumeroSegmentidaAggiungere, DatiSpostamento, this.ArrotondaOrario)

      this.PopupNumeroSegmentiDaAggiungere = false
    },

    OnClickRinumeraSegmenti()
    {
      this.DataTablePopup.RinumeraSegmenti()
    },

    OnClickAdatta()
    {
      this.MixInsOnClickAdattaSpostamenti(this.ObjGrafico)
    },

    DisegnaVelocitaSuGrafico()
    { 
      if(!this.AbilitaDisegnaVelocita)
      {
        this.AbilitaDisegnaVelocita = true
      }
      else
      {
        this.AbilitaDisegnaVelocita = false
        this.DataTablePopup.AggiungiNuoviSegmenti(this.ListaSegmenti, this.ArrotondaOrario)
        for (let i = 0; i < this.DataTablePopup.DataTableSegmenti.Righe.length; i++)
          this.CalcolaVelocitaSegmento(this.DataTablePopup.DataTableSegmenti.Righe[i].Dati)
        this.ConfermaPopupSegmentiVelocita()
      }
    },

    ApriPopupSegmentiVelocita()
    { 
      this.PopupSegmentiVelocita = true
    },

    AnnullaPopupSegmentiVelocita()
    {
      this.PopupSegmentiVelocita = false
    },

    ConfermaPopupSegmentiVelocita()
    {
      this.ListaSegmenti = []
      let OraDal = (this.ObjDal.Ora < 10 ? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00'
      let OraAl = (this.ObjAl.Ora < 10 ? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00' 
      let DataDal = this.ObjDal.Data + 'T' + OraDal
      let DataAl = this.ObjAl.Data + 'T' + OraAl
      
      for (let i = 0; i < this.DataTablePopup.DataTableSegmenti.Righe.length; i++)
      {
        let SingolaRiga = this.DataTablePopup.DataTableSegmenti.Righe[i].Dati

        this.CalcolaVelocitaSegmento(SingolaRiga)
        
        if (SingolaRiga.DAL.Valore < DataDal)
          SingolaRiga.DAL.Valore = DataDal

        if (SingolaRiga.AL.Valore > DataAl)
          SingolaRiga.AL.Valore = DataAl

        let Dal = Date.parse(SingolaRiga.DAL.Valore)
        let Al  = Date.parse(SingolaRiga.AL.Valore)

        this.ListaSegmenti.push({
                                  Label     : SingolaRiga.SEGMENTO.Valore, 
                                  Dal       : Dal, 
                                  Al        : Al,
                                  DalEsteso : SingolaRiga.DAL.Valore,
                                  AlEsteso  : SingolaRiga.AL.Valore,
                                  Velocita  : SingolaRiga.VELOCITA.Valore
                                })
      }
      this.PressAdatta++
      this.PopupSegmentiVelocita = false
    },

    CalcolaVelocitaSegmento(SingolaRiga)
    {
      var SpostamentoIniziale 
      var SpostamentoFinale  

      var VelocitaDal = Date.parse(SingolaRiga.DAL.Valore)
      VelocitaDal     = Math.round(VelocitaDal / (1000 * 60 * 60)) * (1000 * 60 * 60);

      var VelocitaAl  = Date.parse(SingolaRiga.AL.Valore)
      VelocitaAl      = Math.round(VelocitaAl / (1000 * 60 * 60)) * (1000 * 60 * 60);

      if(this.OggettoTotaleSpostamento != undefined && this.OggettoTotaleSpostamento.ListaTotaliSpostamento != undefined)
      {
        for (let i = 0; i < this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length; i++) 
        {
          let DataAttuale = Date.parse(this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].Data)

          if(DataAttuale === VelocitaDal)
            SpostamentoIniziale = this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].SpostamentoTotale

          if(DataAttuale === VelocitaAl)
            SpostamentoFinale = this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].SpostamentoTotale
        }
      }

      if(this.Modulo != undefined)
      {
        let SpostamentoInizialeGrafico

        if(this.Modulo.Dati[0].Roll != null && this.Modulo.Dati[0].Pitch != null)
          SpostamentoInizialeGrafico = this.GetSpostamentoAssePendenza(this.Modulo.Dati[0], this.OrientamentoAsse, this.Modulo.Lunghezza, this.Modulo.Orientamento)

        for (let i = 0; i < this.Modulo.Dati.length; i++) 
        {
          let DataAttuale = Date.parse(this.Modulo.Dati[i].Data)

          if(DataAttuale === VelocitaDal && this.Modulo.Dati[i].Roll != null && this.Modulo.Dati[i].Pitch != null)
            SpostamentoIniziale = this.GetSpostamentoAssePendenza(this.Modulo.Dati[i], this.OrientamentoAsse, this.Modulo.Lunghezza, this.Modulo.Orientamento)

          if(DataAttuale === VelocitaAl && this.Modulo.Dati[i].Roll != null && this.Modulo.Dati[i].Pitch != null)
            SpostamentoFinale = this.GetSpostamentoAssePendenza(this.Modulo.Dati[i], this.OrientamentoAsse, this.Modulo.Lunghezza, this.Modulo.Orientamento)
        }

        if(SpostamentoIniziale != undefined && SpostamentoFinale != undefined && SpostamentoInizialeGrafico != undefined)
        {
          SpostamentoIniziale = SpostamentoIniziale - SpostamentoInizialeGrafico
          SpostamentoFinale   = SpostamentoFinale   - SpostamentoInizialeGrafico
        }
      }

      if(SpostamentoIniziale != undefined && SpostamentoFinale != undefined)
      {
        let DifferenzaSpostamento = SpostamentoFinale - SpostamentoIniziale
        let DifferenzaTempoGiorni = (VelocitaAl - VelocitaDal) / (1000 * 60 * 60 * 24)
        let VelocitaMmGg          = DifferenzaSpostamento / DifferenzaTempoGiorni
        SingolaRiga.VELOCITA.Valore = VelocitaMmGg.toFixed(3)

        SingolaRiga.DAL.Valore = this.ArrotondaOrario(VelocitaDal)
        SingolaRiga.AL.Valore  = this.ArrotondaOrario(VelocitaAl)
      }
      else SingolaRiga.VELOCITA.Valore = this.GetTraduzioneLabel('VUEFrameComponenteGraficoSpostamenti','TKN_FRM_GRAF_ERR_VEL',this.LinguaUtente)
    },

    ArrotondaOrario(Orario)
    {
      let OrarioCompleto= new Date(Orario);
      let OrarioAnno = OrarioCompleto.getFullYear();
      let OrarioMese = String(OrarioCompleto.getMonth() + 1).padStart(2, '0');
      let OrarioGiorno = String(OrarioCompleto.getDate()).padStart(2, '0');
      let OrarioOra = String(OrarioCompleto.getHours()).padStart(2, '0');
      let OrarioMinuti = String(OrarioCompleto.getMinutes()).padStart(2, '0');

      return `${OrarioAnno}-${OrarioMese}-${OrarioGiorno}T${OrarioOra}:${OrarioMinuti}`;
    },

    GetSpostamentoAssePendenza(CampioneSensore, OrientamentoAsse, Lunghezza, Orientamento)
    {
      return (this.GetSpostamentoRoll(Lunghezza, CampioneSensore)  * Math.cos(TZMathFunct.DegToRad(Orientamento + OrientamentoAsse)) +
             this.GetSpostamentoPitch(Lunghezza, CampioneSensore) * Math.sin(TZMathFunct.DegToRad(Orientamento + OrientamentoAsse))) * 1000;
    },

    GetSpostamentoRoll(Lunghezza, CampioneSensore)
    {
      return Lunghezza * Math.sin(TZMathFunct.DegToRad(CampioneSensore.Roll));
    },

    GetSpostamentoPitch(Lunghezza, CampioneSensore)
    {
      return Lunghezza * Math.sin(TZMathFunct.DegToRad(CampioneSensore.Pitch));
    },

    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = this.$refs.DivButtons.clientHeight
    },

    OnClickUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.MixInsConfermaPopupUdmXSpostamenti(this.ObjGrafico)
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      this.MixInsConfermaPopupImpostazioniYSpostamenti(this.ObjGrafico)
    },

    AnnullaPopupImpostazioniY()
    {
      this.MixInsAnnullaPopupImpostazioniYSpostamenti(this.ObjGrafico)
    },

    ApriPopupAddRighello()
    {
      this.PopupAddRighello = true
    },

    ConfermaPopupAddRighello()
    {
      this.MixInsConfermaPopupAddRighelloSpostamenti(this.ObjGrafico)
    },

    AnnullaPopupAddRighello()
    {
      this.PopupAddRighello = false
      this.MixInsResetNewRighelloSpostamenti()
    },

    ApriPopupRemoveRighello()
    {
      this.RighelloToRemove = ''
      this.PopupRemoveRighello = true
    },

    ConfermaPopupRemoveRighello()
    {
      this.MixInsConfermaPopupRemoveRighelloSpostamenti(this.ObjGrafico)
    },

    AnnullaPopupRemoveRighello()
    {
      this.PopupRemoveRighello = false
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    GetUnitaDiMisuraAsseY()
    {
      this.MixInsGetUnitaDiMisuraAsseYSpostamenti()
    },

    ToggleMenuFalde(NumeroMenu)
    {
      if(this.CurrentListaFaldeFiltrata.length > 0)
      {
        if(NumeroMenu == 1)
        {
          this.FlagMenuFalde  = !this.FlagMenuFalde;
          this.FlagMenuFalde2 = false;
          this.FlagMenuFalde3 = false;
        }

        if(NumeroMenu == 2)
        {
          this.FlagMenuFalde  = false;
          this.FlagMenuFalde2 = !this.FlagMenuFalde2;
          this.FlagMenuFalde3 = false;
        }
        
        if(NumeroMenu == 3)
        {
          this.FlagMenuFalde  = false;
          this.FlagMenuFalde2 = false;
          this.FlagMenuFalde3 = !this.FlagMenuFalde3;
        }
      }
    },

    OnClickBottoneAggiungiFalda()
    {
      if(this.ContatoreFalde < 2)
        this.ContatoreFalde++;
    },

    OnClickBottoneSvuotaFalda()
    {
      if(this.ContatoreFalde == 0)
      {
        let IndiceElementoDaRimuovere = this.ListaIdFaldeSelezionate.indexOf(this.FaldaNumero1)

        if(IndiceElementoDaRimuovere != -1)
        {
          this.ListaIdFaldeSelezionate.splice(IndiceElementoDaRimuovere, 1)
          this.ListaFaldeSelezionate.splice(IndiceElementoDaRimuovere, 1); 
        }

        this.FaldaNumero1 = null
        this.ListaFaldeChange++
      }

      if(this.ContatoreFalde == 1)
      {
        let IndiceElementoDaRimuovere = this.ListaIdFaldeSelezionate.indexOf(this.FaldaNumero2)

        if(IndiceElementoDaRimuovere != -1)
        {
          this.ListaIdFaldeSelezionate.splice(IndiceElementoDaRimuovere, 1)
          this.ListaFaldeSelezionate.splice(IndiceElementoDaRimuovere, 1)
        }
        
        this.FaldaNumero2 = null
        this.ListaFaldeChange++
      }

      if(this.ContatoreFalde == 2)
      {
        let IndiceElementoDaRimuovere = this.ListaIdFaldeSelezionate.indexOf(this.FaldaNumero3)
        
        if(IndiceElementoDaRimuovere != -1)
        {
          this.ListaIdFaldeSelezionate.splice(IndiceElementoDaRimuovere, 1)
          this.ListaFaldeSelezionate.splice(IndiceElementoDaRimuovere, 1)  
        }
        
        this.FaldaNumero3 = null
        this.ListaFaldeChange++
      }

      if(this.ContatoreFalde > 0)
        this.ContatoreFalde--;
    }
  },
  
  computed:
  {
    CurrentModulo:
    {
      get()
      {
        return this.Modulo
      }
    },
    
    BottoneConfermaSegmentiAbilitato:
    {
      get()
      {
        let RigaNonValida = this.DataTablePopup.DataTableSegmenti.Righe.find((element) =>
        {
          let SingleRiga = element.Dati
          return SingleRiga.SEGMENTO.Valore == '' ||
                 SingleRiga.DAL.Valore      == '' ||
                 SingleRiga.AL.Valore       == ''
        })
        return RigaNonValida == undefined
      }
    },

    CurrentOggettoTotaleSpostamento:
    {
      get()
      {
        return this.OggettoTotaleSpostamento
      }
    },

    CurrentIsAccelerazione:
    {
      get()
      {
        return this.IsAccelerazione
      }
    },

    CurrentIsVelocita:
    {
      get()
      {
        return this.IsVelocita
      }
    },

    CurrentIsVelocitaGiornaliera:
    {
      get()
      {
        return this.IsVelocitaGiornaliera
      }
    },

    CurrentIsAccelerazioneGiornaliera:
    {
      get()
      {
        return this.IsAccelerazioneGiornaliera
      }
    },

    CurrentListaFalde:
    {
      get()
      {
        return this.ListaFalde
      }
    },

    CurrentListaFaldeFiltrata:
    {
      get()
      {
        let Result = []
        let Trattino = {}
        Trattino.Id = null

        Result = this.CurrentListaFalde.filter(Falda => !this.ListaIdFaldeSelezionate.includes(Falda.Id))
        Result.unshift(Trattino)

        return Result
      }
    },

    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    }
  },

  watch:
  {
    GetDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    },

    GraficiChange:
    {
      handler()
      {
        if(this.OggettoTotaleSpostamento != undefined)
        {
          if(this.OggettoTotaleSpostamento.ModificatoAsseX)
          { 
            this.ObjGrafico.AxisX.Modificato = this.OggettoTotaleSpostamento.ModificatoAsseX
            this.ObjGrafico.AxisX.UdmX       = this.OggettoTotaleSpostamento.AdattaUdmX
            this.ObjGrafico.AxisX.TipoUdmX   = this.OggettoTotaleSpostamento.AdattaTipoUdmX
          }
          this.Repaint++
        }

        if(this.CurrentModulo != undefined)
        {
          if(this.CurrentModulo.ModificatoAsseX)
          {
            this.ObjGrafico.AxisX.Modificato = this.CurrentModulo.ModificatoAsseX
            this.ObjGrafico.AxisX.UdmX       = this.CurrentModulo.AdattaUdmX
            this.ObjGrafico.AxisX.TipoUdmX   = this.CurrentModulo.AdattaTipoUdmX
          }
          this.Repaint++
        }
      }
    }
  },

  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
    window.addEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  },
  
  beforeMount()
  {
    this.MixInsSetObjGraficoSpostamenti(this.ObjGrafico, this.OggettoTotaleSpostamento, this.CurrentModulo)
  },
  
  beforeUnmount()
  {
    window.removeEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  }
}
</script>
<style scoped>
  #ContainerTasti {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0px;
    margin-top: 5px;
  }

  .EtichettaInGrassetto {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 4px;
  }

  .ContainerFalde {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ContainerLabelEBottoneFalda {
    display: flex;
    flex-direction: column;
  }
  
  .ContainerLabelEBottoneFalda ul {
    cursor: pointer;
    flex: 1;
  }

  .ContainerLabelEBottoneFalda ul li {
    width: 100%;
  }

  .ContainerLabelEBottoneFalda ul li a {
    cursor: pointer;
  }

  /* .ContainerBottoniFalda {
    display: flex;
    gap: 5px;
  } */

</style>